// extracted by mini-css-extract-plugin
export default {"container":"_3mv17Gc0","logo":"_1998V6Ah","logoImage":"_1gm26jlI","copy":"_1Ig9fsHw"};